(function(){
  /* Shopify wiring copied verbatim from creatine-starter-kit-v2.
     Only logic change vs v2: the two-offer (subscription / one-time) branch. */
  var variantId=43533787103310;
  var sellingPlan=2655420494;
  var qty=1;
  var shakerVariantId=41679873769550;
  var mixerVariantId=42933942616142;
  var discountCode='LTO-CREATINESTICK';
  var giftDiscountCode='FREESTARTERKIT';

  /* Two offers on the SAME variant. Subscription is the default money path. */
  var selectedOffer='subscription';
  var ctaLabels={
    subscription:'Get the Starter Kit ($27)',
    onetime:'Buy Once ($49.99)'
  };

  /* Loading messages for ATC */
  var loadingSteps=[
    'Checking availability',
    'Reserving your order',
    'Applying discount',
    'Redirecting to checkout'
  ];

  function runLoadingSequence(btns){
    var stepIndex=0;
    var currentInterval=null;
    var spans=[];
    btns.forEach(function(b){
      var sp=b.querySelector('span');
      if(sp) spans.push(sp);
    });

    function showStep(){
      if(stepIndex>=loadingSteps.length){
        if(currentInterval) clearInterval(currentInterval);
        return;
      }
      var msg=loadingSteps[stepIndex];
      if(currentInterval) clearInterval(currentInterval);
      var dots=0;
      currentInterval=setInterval(function(){
        dots=(dots%3)+1;
        var txt=msg+Array(dots+1).join('.');
        spans.forEach(function(sp){sp.textContent=txt});
      },400);
      spans.forEach(function(sp){sp.textContent=msg+'.'});
    }

    showStep();
    return {
      next:function(){ stepIndex++; showStep(); },
      finish:function(){ if(currentInterval) clearInterval(currentInterval); }
    };
  }

  /* Smooth-scroll any in-page CTA down to the PDP / offer section.
     Mirrors Omni, where every "Try Omni Today" is an anchor to #featured-product
     and only the PDP button actually adds to cart. */
  function jvScrollToOffer(){
    var target=document.querySelector('#jv-omni2 #jv-pdp');
    if(target){ target.scrollIntoView({behavior:'smooth',block:'start'}); }
  }
  window.jvScrollToOffer=jvScrollToOffer;

  /* One-time alternative (the "Buy Once" link under the PDP button).
     Mirrors Omni: the main button is the subscription deal; one-time lives
     as a separate link that runs the plain /checkout path. */
  window.jvBuyOnce=function(){ window.jvHandleAddToCart('onetime'); };

  /* The PDP buy button always reads the subscription label; one-time is the
     separate Buy Once link, so the main label never needs to flip. */
  function syncCtaLabels(){
    document.querySelectorAll('#jv-omni2 #jv-pdp .jv-btn-cta span').forEach(function(sp){
      sp.textContent=ctaLabels.subscription;
    });
  }

  /* Offer toggle in the product card. Selecting a card sets the offer + labels. */
  function selectOffer(offer){
    selectedOffer=(offer==='onetime')?'onetime':'subscription';
    document.querySelectorAll('#jv-omni2 .jv-offer-opt').forEach(function(el){
      el.classList.toggle('jv-selected',el.getAttribute('data-offer')===selectedOffer);
      var radio=el.querySelector('input[type="radio"]');
      if(radio) radio.checked=(el.getAttribute('data-offer')===selectedOffer);
    });
    syncCtaLabels();
  }
  window.jvSelectOffer=selectOffer;

  /* ATC. Branches on selectedOffer. */
  window.jvHandleAddToCart=function(offer){
    if(offer==='subscription'||offer==='onetime'){ selectedOffer=offer; }
    var btns=document.querySelectorAll('#jv-omni2 #jv-pdp .jv-btn-cta');
    btns.forEach(function(b){b.style.opacity='.85';b.style.pointerEvents='none'});

    var seq=runLoadingSequence(btns);

    var isSub=(selectedOffer==='subscription');

    /* Subscription: variant + selling plan + both gifts. One-time: variant only. */
    var items=isSub
      ? [
          {id:variantId,quantity:qty,selling_plan:sellingPlan},
          {id:shakerVariantId,quantity:1},
          {id:mixerVariantId,quantity:1}
        ]
      : [
          {id:variantId,quantity:qty}
        ];

    fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}})
    .then(function(){
      seq.next();
      return fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:items})
      });
    })
    .then(function(r){if(!r.ok)throw new Error('Cart error');return r.json()})
    .then(function(){
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,800)});
    })
    .then(function(){
      seq.next();
      return new Promise(function(resolve){setTimeout(resolve,600)});
    })
    .then(function(){
      seq.finish();
      if(isSub){
        /* Subscription path: carry both codes to checkout via the comma-separated
           ?discount= query param. We deliberately do NOT navigate through
           /discount/{code} permalinks: when Shopify can't apply a permalink code
           (usage cap, one-per-customer already used, a stale discount_code cookie,
           or a redirect target it rejects) it bounces the browser to the storefront
           HOMEPAGE. That fallback is why a normal (cookie-bearing) browser kept
           landing on the home page while a fresh private window always reached
           checkout. The ?discount= query param instead silently drops an unusable
           code and still lands the customer on /checkout with the cart intact.
           NOTE: for both codes to STACK they must be set "Combinable" in Shopify
           admin (Discounts > code > Combinations); otherwise Shopify applies only
           one regardless of URL form. */
        window.location.href='/checkout?discount='+discountCode+','+giftDiscountCode;
      } else {
        /* One-time path: plain checkout, no selling plan, no gifts, no discounts.
           Lands at the variant full one-time price (about $49.99).
           Gevin to confirm the exact one-time price in Shopify. */
        window.location.href='/checkout';
      }
    })
    .catch(function(e){
      console.error(e);
      seq.finish();
      btns.forEach(function(b){ b.style.opacity='';b.style.pointerEvents=''; });
      syncCtaLabels();
    });
  };

  /* Offer toggle click wiring */
  document.querySelectorAll('#jv-omni2 .jv-offer-opt').forEach(function(el){
    el.addEventListener('click',function(){
      selectOffer(el.getAttribute('data-offer'));
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('#jv-omni2 .jv-faq-q').forEach(function(q){
    q.addEventListener('click',function(){
      var item=this.parentElement;
      var wasOpen=item.classList.contains('jv-open');
      document.querySelectorAll('#jv-omni2 .jv-faq-item.jv-open').forEach(function(i){i.classList.remove('jv-open')});
      if(!wasOpen) item.classList.add('jv-open');
    });
  });

  /* Benefit tabs (Pick a Benefit) */
  document.querySelectorAll('#jv-omni2 .jv-tab').forEach(function(tab){
    tab.addEventListener('click',function(){
      var key=tab.getAttribute('data-tab');
      document.querySelectorAll('#jv-omni2 .jv-tab').forEach(function(t){t.classList.toggle('jv-tab-active',t===tab)});
      document.querySelectorAll('#jv-omni2 .jv-tab-panel').forEach(function(p){
        p.classList.toggle('jv-tab-panel-active',p.getAttribute('data-panel')===key);
      });
    });
  });

  /* PDP image-stack gallery: thumbnail select + prev/next cycling. */
  (function(){
    var mainImg=document.querySelector('#jv-omni2 #jv-gallery-img');
    var thumbs=[].slice.call(document.querySelectorAll('#jv-omni2 .jv-thumb'));
    if(!mainImg||!thumbs.length) return;
    var idx=0;
    function show(i){
      idx=(i+thumbs.length)%thumbs.length;
      var src=thumbs[idx].getAttribute('data-img');
      mainImg.setAttribute('src',src);
      thumbs.forEach(function(t,n){ t.classList.toggle('jv-thumb-active',n===idx); });
    }
    thumbs.forEach(function(t,n){ t.addEventListener('click',function(){show(n);}); });
    var prev=document.querySelector('#jv-omni2 .jv-gallery-prev');
    var next=document.querySelector('#jv-omni2 .jv-gallery-next');
    if(prev) prev.addEventListener('click',function(){show(idx-1);});
    if(next) next.addEventListener('click',function(){show(idx+1);});
    /* Swipe (touch) + drag (mouse) on the main image to slide between photos. */
    var main=document.querySelector('#jv-omni2 .jv-gallery-main');
    if(main){
      var tx=null;
      main.addEventListener('touchstart',function(e){ tx=e.touches[0].clientX; },{passive:true});
      main.addEventListener('touchend',function(e){ if(tx===null) return; var dx=e.changedTouches[0].clientX-tx; if(Math.abs(dx)>40) show(dx<0?idx+1:idx-1); tx=null; },{passive:true});
      var mx=null;
      main.addEventListener('pointerdown',function(e){ if(e.pointerType==='touch') return; mx=e.clientX; main.style.cursor='grabbing'; });
      window.addEventListener('pointerup',function(e){ if(mx===null) return; var dx=e.clientX-mx; main.style.cursor='grab'; if(Math.abs(dx)>40) show(dx<0?idx+1:idx-1); mx=null; });
    }
  })();

  /* UGC video wall: no autoplay. Lazy-load the first frame when the tile nears
     the viewport (keeps load light), then play/pause and mute on demand.
     Unmuting one clip mutes the others so audio never overlaps. */
  (function(){
    var tiles=[].slice.call(document.querySelectorAll('#jv-omni2 .jv-vid'));
    if(!tiles.length) return;
    var els=tiles.map(function(t){ return t.querySelector('.jv-vid-el'); });
    function load(v){
      if(!v.getAttribute('src') && v.dataset.src){
        v.setAttribute('preload','metadata');
        v.setAttribute('src',v.dataset.src+'#t=0.1');
      }
    }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ load(e.target); }
          else if(!e.target.paused){ e.target.pause(); }
        });
      },{rootMargin:'300px 0px'});
      els.forEach(function(v){ io.observe(v); });
    } else { els.forEach(load); }
    tiles.forEach(function(tile,i){
      var v=els[i];
      var playBtn=tile.querySelector('.jv-vid-toggle');
      var muteBtn=tile.querySelector('.jv-vid-mute');
      if(playBtn) playBtn.addEventListener('click',function(){
        if(v.paused){ load(v); var p=v.play(); if(p&&p.catch) p.catch(function(){}); }
        else { v.pause(); }
      });
      v.addEventListener('play',function(){ tile.classList.add('jv-playing'); });
      v.addEventListener('pause',function(){ tile.classList.remove('jv-playing'); });
      if(muteBtn) muteBtn.addEventListener('click',function(){
        if(v.muted){
          els.forEach(function(o,j){ if(o!==v){ o.muted=true; tiles[j].classList.remove('jv-unmuted'); } });
          v.muted=false; tile.classList.add('jv-unmuted');
        } else { v.muted=true; tile.classList.remove('jv-unmuted'); }
      });
    });
  })();

  /* Verified-reviews carousel arrows (carousel itself scrolls/snaps natively). */
  (function(){
    var car=document.querySelector('#jv-omni2 .jv-rev-carousel');
    if(!car) return;
    var prev=document.querySelector('#jv-omni2 .jv-rev-prev');
    var next=document.querySelector('#jv-omni2 .jv-rev-next');
    var step=340;
    if(prev) prev.addEventListener('click',function(){ car.scrollBy({left:-step,behavior:'smooth'}); });
    if(next) next.addEventListener('click',function(){ car.scrollBy({left:step,behavior:'smooth'}); });
  })();

  /* Initialize labels + Lucide */
  selectOffer('subscription');
  if(window.lucide){lucide.createIcons();}
})();
